module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/TriangleUpSolidSmall.4c620019.svg";